/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from './TextInput';
import { useValidationMessagingArgs, ValidationStates } from './ValidationMessages';

interface EmailProps {
    initialValue?: string;
}

const verification: useValidationMessagingArgs = {
    applicableStates: [ValidationStates.MissingRequired],
};

export const Email: React.FC<EmailProps> = ({ initialValue }) => {
    const { t } = useTranslation(['common']);

    return (
        <TextInput
            formFieldId="email"
            isRequired
            inputValidation={verification}
            label={t('common:emailAddress')}
            name="Email"
            initialValue={initialValue}
        />
    );
};
